var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEasy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0003 3.33439C8.10929 3.33439 3.33366 8.11002 3.33366 14.0011C3.33366 19.8921 8.10929 24.6677 14.0003 24.6677C19.8914 24.6677 24.667 19.8921 24.667 14.0011C24.667 8.11002 19.8914 3.33439 14.0003 3.33439ZM0.666992 14.0011C0.666992 6.63726 6.63653 0.667725 14.0003 0.667725C21.3641 0.667725 27.3337 6.63726 27.3337 14.0011C27.3337 21.3649 21.3641 27.3344 14.0003 27.3344C6.63653 27.3344 0.666992 21.3649 0.666992 14.0011Z",
    fill: "#AAAAAA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66699 11.3344C8.66699 10.598 9.26395 10.0011 10.0003 10.0011H10.0137C10.75 10.0011 11.347 10.598 11.347 11.3344C11.347 12.0708 10.75 12.6677 10.0137 12.6677H10.0003C9.26395 12.6677 8.66699 12.0708 8.66699 11.3344Z",
    fill: "#AAAAAA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.667 11.3344C16.667 10.598 17.2639 10.0011 18.0003 10.0011H18.0137C18.75 10.0011 19.347 10.598 19.347 11.3344C19.347 12.0708 18.75 12.6677 18.0137 12.6677H18.0003C17.2639 12.6677 16.667 12.0708 16.667 11.3344Z",
    fill: "#AAAAAA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33366 18.0011C9.33366 17.2647 9.93061 16.6677 10.667 16.6677H17.3337C18.07 16.6677 18.667 17.2647 18.667 18.0011C18.667 18.7374 18.07 19.3344 17.3337 19.3344H10.667C9.93061 19.3344 9.33366 18.7374 9.33366 18.0011Z",
    fill: "#AAAAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEasy);
export default __webpack_public_path__ + "static/media/easy.8eaad3ea7c805b72981995892f668c65.svg";
export { ForwardRef as ReactComponent };